<template>
  <div class="myInvite">
    <h3 class="headerTitle">我的邀请</h3>
    <el-row class="data-card" :gutter="20">
      <el-col :span="10">
        <div class="data-card-item store">
          <div class="icon">
            <i class="el-icon-pie-chart"></i>
          </div>
          <div class="data">
            <div class="data-amount">
              <span class="num">{{inviteData.recommendCount}}</span>
              <span class="unit">家</span>
            </div>
            <div class="data-label">推荐总数</div>
          </div>
          <el-button type="primary" plain round size="mini" class="btn-enter" @click="$router.push('/myInviteData')">明细</el-button>
        </div>
      </el-col>
      <el-col :span="7">
      <div class="data-card-item money">
        <div class="icon">
          <i class="el-icon-money"></i>
        </div>
        <div class="data">
          <div class="data-amount">
            <span class="num">{{inviteData.recommendStatistic.tradeAmount | decimal}}</span>
            <span class="unit">元</span>
          </div>
          <div class="data-label">今日交易总额</div>
        </div>
      </div>
      </el-col>
      <el-col :span="7">
      <div class="data-card-item count">
        <div class="icon">
          <i class="el-icon-coin"></i>
        </div>
        <div class="data">
          <div class="data-amount">
            <span class="num">{{inviteData.recommendStatistic.tradeCount}}</span>
            <span class="unit">笔</span>
          </div>
          <div class="data-label">今日交易笔数</div>
        </div>
      </div>
      </el-col>
    </el-row>
    <div class="group-label">商家列表</div>
    <el-table :data="storeList">
      <el-table-column
        width="100"
        prop="name"
        label="logo">
        <template slot-scope="scope">
          <el-avatar :src="scope.row.logo" size="medium" shape="circle"></el-avatar>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称">
      </el-table-column>
      <el-table-column
        prop="sortname"
        label="类别">
      </el-table-column>
      <el-table-column
        prop="phone"
        label="联系电话">
      </el-table-column>
      <el-table-column
        label="地址">
        <template slot-scope="scope">
          {{scope.row.companyLocationName}}{{scope.row.address}}
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="{ total, pageSize, currentPage: pageIndex }" @callFather="handlePageChange"></Pagination>
  </div>
</template>

<script type="text/ecmascript-6">
import { fetchTodayData,fetchInviteStoreList } from '../../../api/xunyou';
import Pagination from '@/components/Pagination';
export default {
  name: 'myInvite',
  components: {
    Pagination
  },
  data() {
    return {
      inviteData: {
        recommendCount: 0,
        recommendStatistic: {
          tradeAmount: 0,
          tradeCount: 0
        }
      },
      pageIndex: 1,
      pageSize: 10,
      storeList:[],
      total: 0,
      loading: false
    }
  },
  computed: {
    userId () {
      return this.$store.getters.userId;
    }
  },
  created () {
    this.getTodayData();
    this.search();
  },
  methods: {
    getTodayData () {
      this.loading = true;
      fetchTodayData({ recommUid: this.userId}).then(res => {
        console.log('邀请数据：', res);
        if (res.code === 0) {
          this.inviteData = res.data;
        }
      }).catch(err => {
        console.error('错误：', err);
      }).finally(() => {
        this.loading = false;
      });
    },
    search () {
      this.pageIndex = 1;
      this.getInviteStoreList();
    },
    handlePageChange (val) {
      this.pageSize = val.pageSize;
      this.pageIndex = val.currentPage;
      this.getInviteStoreList();
    },
    getInviteStoreList () {
      const params = {
        pageNum: this.pageIndex,
        pageSize: this.pageSize,
        recommendMuid: this.userId
      }
      fetchInviteStoreList(params).then(res => {
        console.log('店铺列表：', res);
        if (res.code === 0) {
          this.total = res.total;
          this.storeList = res.rows;
        }
      }).catch(err => {
        console.error('错误：', err);
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.headerTitle {
  font-size: 20px;
  color: #666;
}
.data-card{
  margin: 15px 0;
}
.data-card-item{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: 0px 0px 10px rgba(222,222,222,0.4);
  .icon{
    height: 80px;
    padding: 0 25px;
    line-height: 80px;
    text-align: center;
    font-size: 30px;
    color: #ffffff;
  }
  &.store .icon{
    background-color: var(--main-theme-color);
  }
  &.money .icon{
    background-color: #ff902e;
  }
  &.count .icon{
    background-color: #6ac4ae;
  }
  .data{
    flex: 1;
    padding: 0 15px;
    .num{
      font-size: 32px;
    }
    .data-label{
      color: #999999;
    }
  }
  .btn-enter{
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/myOrder/myInvite/myInvite.vue